/* These reducers are same for acronymIgnoreList, discoveryIgnoreList and readabilityIgnoreList */
export const ignoreListReducers = {
  setEditedList: (state, action) => {
    state.ignoreList = action.payload;
    state.hasBeenEdited = true;
  },
  deleteTerm: (state, action) => {
    const updatedList = [...state.ignoreList];
    updatedList.splice(action.payload, 1);

    state.ignoreList = updatedList;
    state.hasBeenEdited = true;
  },
  cancelEdits: (state) => {
    state.ignoreList = state.unchangedIgnoreList;
    state.unchangedIgnoreList = [];
    state.hasBeenEdited = true;
  },
  setEditMode: (state, action) => {
    const editMode = action.payload;

    if (editMode) {
      state.editMode = true;
      state.unchangedIgnoreList = [...state.ignoreList];
    } else {
      state.editMode = false;
    }
  },
  setLocked: (state, action) => {
    state.locked = action.payload;
  },
};
